import { useGlobalContext } from "../../context";
import { useEffect, useState } from "react";
import CurrencyFormat from "react-currency-format"
import { useNavigate } from "react-router-dom";
import { newOrder } from "../../requests/orderRequest";
import { handleGetAddress } from "../../requests/userRequests";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

function DetailPrice() {
    const user = useAuthUser()
    const navigate = useNavigate()
    const { cart, route , handleErr , savedAddress , setSavedAddress} = useGlobalContext()
    const [total, setTotal] = useState()
    const [mT800, setMT800] = useState(false)
    useEffect(() => {
        setTotal(
            cart.reduce((a, c) => a + c.price * c.qty, 0)
        )
        if (total >= 800000) {
            setMT800(true)
        } else {
            setMT800(false)
        }
    }, [cart, total])
    const checkAddress = () => {
        const selectedItem = savedAddress.find((item) => item.chosen)
        if(!selectedItem){
            return handleErr("error" ,  "آدرس خود را انتخاب کنید.")
        }else{
            navigate("/cart/payment")
        }
    }
    console.log(savedAddress)
    useEffect(async () => {
        const res1 = await handleGetAddress(user._id)
        setSavedAddress(res1.address)
    } , [])
    console.log(savedAddress)
    const handleNewOrder = async () => {
        let order = {
            userId : user._id,
            products : cart,
            amount : total,
            address : savedAddress,
        }
        const res = await newOrder(order , user._id)
        return handleErr(res.type , res.massage)
    }
    return (
        <div className="left-cart">
            <div className="l-c-container">
                <div className="l-c-c-content">
                    <ul>
                        <li>جزعیات سفارش</li>
                        <li>
                            <span>تعداد :</span>
                            <span>{cart.length}</span>
                        </li>
                        <li>
                            <span>جمع کل :</span>
                            <span>
                                <CurrencyFormat thousandSeparator={true}
                                    value={total}
                                    prefix="تومان"
                                    displayType="text">
                                </CurrencyFormat>
                            </span>
                        </li>
                        <li>
                            <span>هزینه ارسال :</span>
                            <span>
                                <CurrencyFormat thousandSeparator={true}
                                    value={cart.length >= 1 ? mT800 ? 0 : 100000 : 0}
                                    prefix="تومان"
                                    displayType="text">
                                </CurrencyFormat>
                            </span>
                        </li>
                        <li>
                            <span>قابل پرداخت :</span>
                            <span>
                                <CurrencyFormat thousandSeparator={true}
                                    value={total}
                                    prefix="تومان"
                                    displayType="text">
                                </CurrencyFormat>
                            </span>
                        </li>
                    </ul>
                    <span>ارسال رایگان برای خرید بالای 800 هزار تومن</span>
                    {
                        route == "cartTable" &&
                        <button onClick={() => cart.length >= 1 ? navigate("/cart/shipping") : handleErr("error" , "محصولی در سبد خرید وجود ندارد.")}>تایین آدرس</button>
                    }
                    {
                        route == "shipping" &&
                        <button onClick={() => checkAddress()}>پرداخت</button> 
                    }
                    {
                        route == "payment" &&
                        < button onClick={() => handleNewOrder()}>صفحه پرداخت</button>
                    }
                </div>
            </div>
        </div >
    )
}

export default DetailPrice;